import { Box, Checkbox, FormControl, FormControlLabel, Stack, Typography } from '@mui/material'
import { useControllerActions } from '../../../../../hooks/useControllerActions'
import { useController } from '../../../../../hooks/useController'
import { useTexts } from '../../../../../hooks/useTexts'

interface Props {
  testId?: string
  trackId?: string
}

export function CustomizeColumns(props: Props) {
  const { testId = 'export-customize-columns-flag' } = props
  const trackId = props.trackId ?? testId

  const {
    data: { customizeColumns },
  } = useController()

  const handlers = useControllerActions()

  const texts = useTexts()

  return (
    <FormControl>
      <Stack data-testid={testId} data-trackid={trackId}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={(_, checked) => handlers.onChangeCustomizeColumns(checked)}
              checked={customizeColumns}
            />
          }
          label={texts.customizeColumns}
        />

        <Box ml={4}>
          <Typography variant="caption">{texts.customizeColumnsDescription}</Typography>
        </Box>
      </Stack>
    </FormControl>
  )
}
